import React, { PropsWithChildren } from "react";

import MuiTypography from "@mui/material/Typography";

import { TypographyVariant } from "@/theme/components/TypographyOverrides.ts";
import { PaletteColors } from "@/theme/PaletteOverrides.ts";
import { AtomProps } from "@/uiKit/atoms/utils/AtomTypes.ts";

type BaseTypographyProps = PropsWithChildren<{
  variant?: TypographyVariant;
  component?: React.ElementType;
  color?: PaletteColors;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}>;

export type TypographyProps = AtomProps<BaseTypographyProps>;

export const Typography: React.FC<TypographyProps> = ({ children, ...props }) => (
  <MuiTypography {...props}>{children}</MuiTypography>
);
